<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 class="modal-title" data-cy="transportOrderRefundDialogHeading" jhiTranslate="MODAL_REFUND_BILL.TITLE" [translateValues]="{ ot: basketOrder.billNumber }">
      refundBill.title
    </h4>
  </div>
  <div class="modal-body text-left">
    <div class="d-flex flex-row w-100">
      <div class="d-flex flex-column flex-fill justify-content-center ml-4">
        <strong>{{ basketOrder.billAddressFullname }}</strong>
        <span>{{ basketOrder.billAddressStreetNumber }}&nbsp;{{ basketOrder.billAddressStreet }}</span>
        <span>{{ basketOrder.billAddressZipCode }}&nbsp;{{ basketOrder.billAddressCity }}</span>
        <span>{{ basketOrder.billAddressCountry | countryName }}</span>
      </div>

      <div class="d-flex flex-fill flex-column text-right mr-4">
        <div>
          <strong class="mr-2">{{ 'LABEL.PAYMENT_METHOD' | translate }}&nbsp;:</strong>
          <strong>{{ getPaymentMethod() }}</strong>
        </div>
        <div class="my-2">
          <jhi-bary-badge [options]="basketOrder.statusBadgeOpts()"></jhi-bary-badge>
        </div>
        <div>
          <strong>{{ 'MODAL_REFUND_BILL.SUBTITLE.DATE' | translate }}&nbsp;:</strong>
          <span>{{ basketOrder.dueDate?.toDate() | date: 'dd/MM/yy' }}</span>
        </div>
      </div>
    </div>
    <jhi-bary-input-text class="d-block w-100 my-3" [control]="searchTerm" [placeholder]="'MODAL_REFUND_BILL.SEARCHTERM.PLACEHOLDER' | translate"></jhi-bary-input-text>
    <div class="bary-table-list pb-4">
      <table mdbTable [responsive]="true" [hover]="true" [small]="true" class="table-responsive-lg no-spacing vh-40">
        <thead>
          <tr jhiSort>
            <th class="px-2 text-left">
              <span class="no-capitalize" jhiTranslate="LABEL.OT">ot</span>
            </th>
            <th class="px-2 text-left">
              <span jhiTranslate="LABEL.PICKUP">pickup</span><br />
              <span jhiTranslate="LABEL.DELIVERY">delivery</span>
            </th>
            <th class="px-2 text-left">
              <span jhiTranslate="LABEL.PICKUP_DATE">pickupDate</span><br />
              <span jhiTranslate="LABEL.DELIVERY_DATE">deliveryDate</span>
            </th>
            <th class="px-2 text-left">
              <span jhiTranslate="LABEL.WEIGHT">totalWeight</span>
            </th>
            <th class="px-2 text-left">
              <span class="no-capitalize" jhiTranslate="LABEL.UM">billingQuantity</span>
            </th>
            <th class="px-2 text-left w-50px">
              <span class="no-capitalize" jhiTranslate="LABEL.PRE_TAXES_PRICE">priceHt</span>
              <jhi-bary-icon icon="info-circle" [faDirective]="FAS" [title]="'TOOLTIP_MESSAGE.PRE_TAXES_PRICE_DETAILS' | translate"></jhi-bary-icon>
            </th>
            <th class="px-2 text-left">
              <span class="no-capitalize" jhiTranslate="LABEL.REFUND_AMOUNT">refundAmount</span>
            </th>
            <th class="px-2 text-left">
              <span jhiTranslate="LABEL.REASON">reason</span>
            </th>
            <th class="px-2 text-left">
              <span jhiTranslate="LABEL.CONTRACTOR">contractor</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let transportOrder of transportOrderReviewRefundListFilter">
            <tr mdbTableRow>
              <td rowspan="2">
                <span class="text-uppercase table-transport-type-icon d-flex align-items-center">{{ transportOrder.id }}</span>
              </td>
              <td rowspan="2">
                {{ transportOrder.pickupAddressCity }}
                <br />
                {{ transportOrder.deliveryAddressCity }}
              </td>
              <td rowspan="2">
                {{ transportOrder.pickupDate }}
                <br />
                {{ transportOrder.deliveryDate }}
              </td>
              <td rowspan="2">{{ transportOrder.totalWeight }} {{ 'MEASURE_UNIT.KILOGRAM' | translate }}</td>
              <td rowspan="2">{{ transportOrder.billingQuantity }}</td>
              <td rowspan="2">
                {{ transportOrder.priceHTWithGazoleTax | currency: 'EUR' }}
                <span
                  *ngIf="transportOrder.transportRefundAmountHT > 0"
                  class="text-danger mb-2"
                  [mdbTooltip]="'MODAL_REFUND_BILL.TOOLTIP.ALREADY_REFUND' | translate: { transportRefundAmount: transportOrder.transportRefundAmountHT }"
                  ><i class="fas fa-info-circle text-info"></i
                ></span>
              </td>
              <td>
                <jhi-bary-input-price
                  data-id-cypress="input-refund-amount"
                  [control]="transportOrder.form.get('refundAmount')! | asFormControl"
                  [min]="0"
                  [max]="transportOrder.transportRefundMaxAmountHT"
                >
                </jhi-bary-input-price>
              </td>
              <td>
                <jhi-bary-input-select
                  class="d-block input-form"
                  [id]="'test-input-select'"
                  [control]="transportOrder.form.get('reason')! | asFormControl"
                  [options]="option"
                  data-id-cypress="select-refund-reason"
                ></jhi-bary-input-select>
              </td>
              <td>
                <span
                  ><jhi-bary-input-text
                    class="d-block input-form"
                    data-id-cypress="input-refund-contractor"
                    [control]="transportOrder.form.get('contractor')! | asFormControl"
                  ></jhi-bary-input-text
                ></span>
              </td>
            </tr>
            <tr>
              <td class="text-danger border-0" colspan="3" *ngIf="transportOrder.form.errors?.['refundRequired']">
                <div>{{ 'ERROR.ALL_FIELDS_REQUIRED' | translate }}</div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="row mt-2 mx-4">
      <div class="col-12 col-md-8">
        <jhi-bary-input-checkbox data-id-cypress="input-refund-accept" [control]="acceptAllRefunds" [label]="'MODAL_REFUND_BILL.SUB_BLOCK.CHECKBOX' | translate">
        </jhi-bary-input-checkbox>
      </div>
      <div class="col-12 col-md-4">
        <jhi-cart-group-value
          label="{{ 'LABEL.TOTAL_PRE_TAXES_PRICE' | translate }}"
          [items]="getBillHTItems()"
          [value]="basketOrder.priceHt! | currency: 'EUR'"
        ></jhi-cart-group-value>
        <jhi-cart-value [label]="'LABEL.VAT_DEFAULT' | translate" [value]="basketOrder.vat | currency: 'EUR'"></jhi-cart-value>
        <jhi-cart-value [label]="'LABEL.TOTAL_FULL_TAXES_PRICE' | translate" [value]="basketOrder.price | currency: 'EUR'" color="bold color-dark"></jhi-cart-value>
        <hr class="mt-0" *ngIf="getOldTotalRefund() > 0" />
        <jhi-cart-value
          *ngIf="getOldTotalRefund() > 0"
          [suffix]="'SUFFIX.FULL_TAXES' | translate"
          [label]="'LABEL.ALREADY_REFUND' | translate"
          [value]="-getOldTotalRefund() | currency: 'EUR'"
        ></jhi-cart-value>
        <hr class="mt-0" />
        <jhi-cart-value [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_HT_TO_REFUND' | translate" [value]="getRefundHt() | currency: 'EUR'" [color]="'text-danger'"></jhi-cart-value>
        <jhi-cart-value [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_VAT_TO_REFUND' | translate" [value]="getRefundVat() | currency: 'EUR'" [color]="'text-danger'"></jhi-cart-value>
        <jhi-cart-value
          [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_TTC_TO_REFUND' | translate"
          [value]="getRefundTTC() | currency: 'EUR'"
          [color]="'text-danger bold'"
        ></jhi-cart-value>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <jhi-bary-button
        (clickEvent)="handleSubmit()"
        [label]="'BTN.SUBMIT' | translate"
        color="primary"
        data-id-cypress="btn-refund-valid"
        [disabled]="!acceptAllRefunds.value || forms.invalid || getAllRefundSaisie() === 0"
      ></jhi-bary-button>
    </div>
  </div>
</div>
